import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { ExchangeDifferenceCalculationsDetail } from "../../../components/Pages/Documents/ExchangeDifferenceCalculations/ExchangeDifferenceCalculationsDetail";
import { CreateExchangeDifferenceCalculationsDto } from "../../../dtos/documents/ExchangeDifferenceCalculations/CreateExchangeDifferenceCalculationsDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ExchangeDifferenceCalculationsService } from "../../../services/documents/ExchangeDifferenceCalculationsService";
import { NFLookupExchangeDifferenceCalculations } from "../../../components/Shared/NewForms/NFlookupExchangeDifferenceCalculations";
import ExchangeDifferenceCalculationsList from "../../../components/Pages/Documents/ExchangeDifferenceCalculations/ExchangeDifferenceCalculationsList";

export const ExchangeDifferenceCalculations: IAppEntity = {
  entityType: "document",
  title: "Exchange Difference Calculations",
  pluralTitle: "Exchange Difference Calculations",
  apiUrl: "ExchangeDifferenceCalculations",
  apiEnum: ReferenceTypes.DocumentExchangeDifferenceCalculation,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ExchangeDifferenceCalculationsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ExchangeDifferenceCalculationsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupExchangeDifferenceCalculations, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () =>
    new ExchangeDifferenceCalculationsService("ExchangeDifferenceCalculations"),
  getEmptyModel: () => {
    const model: CreateExchangeDifferenceCalculationsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      documentNumber: "",
      documentDate: new Date(),
      createdDate: new Date(),
    };
    return model;
  },
};
